import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  AppointmentService,
  AppointmentTypesService,
  ClientService,
  TimeconversionService,
} from '@fitness-force/api';
import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import {
  AppointmentById,
  AppointmentType,
  AppointmentTypeById,
  CreateAppointmentRequest,
  CreateRecurringAppointmentRequest,
  RepeatRuleResponse,
} from '@fitness-force/models';

import { Store } from '@ngrx/store';
import {
  APPOINTMENT_TYPE_STATE,
  STAFF_STATE,
} from 'apps/ff-frontend/src/app/state/app.state';
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject, Observable } from 'rxjs';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {
  ClassAppointmentBehaviour,
  Ienum,
  StaffStatus,
} from '@fitness-force/enum';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import {  ShortNamePipe } from '@fitness-force/pipes/short-name'
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { RruleComponent } from '../../../rrule/rrule.component';
import { SelectRoomComponent } from '../../../select-room/select-room.component';

import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { StaffAppointmentTypeLinkService } from 'libs/staff-availability-lib/src/lib/services/staff-appointment-type-link.service';
import { StaffAppointmentTytpeLink, StaffAppointmentTytpeLinkResponse } from 'libs/staff-availability-lib/src/lib/models/StaffAppointmentTytpeLink';
import { MessageModule } from 'primeng/message';
@Component({
  selector: 'duplicate-appointment',
  templateUrl: './duplicate-appointment.component.html',
  styleUrls: ['./duplicate-appointment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    SelectModule,
    FormsModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    PopoverModule,
    RadioButtonModule,
    TooltipModule,
    MessageModule,
    DrawerModule,
    ToggleSwitchModule,
    ShortNamePipe,
    SelectRoomComponent,
    TranslateModule
]
})
export class DuplicateAppointmentComponent implements OnInit {
  @Input('visible') duplicateAppointment: boolean = false;
  @Input('tenantId') tenantId: number = 0;
  @Input('form') form: FormGroup;
  @Input('appointmentData') appointment!: AppointmentById;
  @Output('CloseDuplicateAppointment') hideDuplicateAppointment: EventEmitter<any> = new EventEmitter();

  getAccessedStaffList$: Observable<any> | any;
  appointmentTypeList$ = new BehaviorSubject<any[]>([]);
  appointmentSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$: Observable<any> | any;

  selectedApptType: Observable<any> | any;
  selectedApptSubType: Observable<any> | any;
  duplicateAppointmentForm: FormGroup = new FormGroup({});
  disableSaveBtn: boolean = false;
  selectedTrainerId = new BehaviorSubject(0);
  selectedRoomId = new BehaviorSubject(0);
  minimumDate = new Date();


  appointmentTypes: any[];
  selectedAppointmentType: { name: string, icon: string } | undefined;


  types = ClassAppointmentBehaviour;
  errorMessages: never[];
  behaviours(): Array<string> {
    var keys = Object.keys(this.types);
    return keys.slice(keys.length / 2);
  }

  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};

  error = new BehaviorSubject(null as (AppErrors | null));
  showErrorPopup$ = new BehaviorSubject(false);
  filterStaffIds = new BehaviorSubject<number[]>([0]);

  isVirtal: boolean = false;
  staffAppointmentTypeLinks = [] as StaffAppointmentTytpeLink[];
  allStaffs:[]= [];


  constructor(
    private http: HttpClient,
    private store: Store,
    private translate: TranslateService,
    private fb: FormBuilder,
    private toastMessageService: ToastMessageService,
    private apptTypeService: AppointmentTypesService,
    private appointmentService: AppointmentService,
    private timeConversionService: TimeconversionService,
    public datePipe: DatePipe,
    private clientService: ClientService,
    private staffAppointmentTypeLinkService: StaffAppointmentTypeLinkService,
    public cd: ChangeDetectorRef
  ) {
    this.appointmentTypes = [
      { name: 'PHYSICAL', icon: 'fa fa-building' },
      { name: 'VIRTUAL', icon: 'fa fa-video' }
  ];
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.isVirtal = this.appointment?.is_virtual;
    this.duplicateAppointmentForm = this.form!;
    this.selectedTrainerId.next(this.appointment?.coach_id);
    this.selectedRoomId.next(this.appointment?.room_id);

    if (this.isVirtal)
      this.selectedAppointmentType = this.appointmentTypes.find(o => o.name.toLowerCase() == 'virtual');
    else this.selectedAppointmentType = this.appointmentTypes.find(o => o.name.toLowerCase() == 'physical');

    this.SelectedBehaviourFormControl.setValue(this.selectedAppointmentType);
    this.GetStaffs();
    this.GetAppointmentTypes();
  }

  GetAppointmentTypes() {
    this.store.select(APPOINTMENT_TYPE_STATE).subscribe((responseData: AppointmentType[]) => {
      this.appointmentTypeList$.next(responseData);
      this.selectedApptType = this.appointmentTypeList$.value.find(
        (type: { id: number }) => type.id == this.appointment.type_id
      );
      this.GetAppointmentSubTypes(this.appointment!.type_id);
      this.GetStaffAppointmentLink( this.selectedApptType.id);
    });
  }

  GetAppointmentSubTypes(appointmentTypeId: number) {
    this.apptTypeService.getSingleAppointmentType(this.tenantId, appointmentTypeId).subscribe({
      next: (response: AppointmentTypeById) => {
        if (response.subtypes) {
          this.appointmentSubTypeList$.next(response.subtypes);
          this.selectedApptSubType = response.subtypes.find(o => o.name_primary_language.toLowerCase() == this.appointment!.subtype_name_primary_language.toLowerCase())!;
          if (this.selectedApptSubType) this.SelectedApptSubTypeFormControl.setValue(this.selectedApptSubType)
          else this.SelectedApptSubTypeFormControl.setValue(response.subtypes[0]);
        }
        else {
          this.appointmentSubTypeList$.next([]);
        }
      },
      error: (error) => {
      },
    });
  }


  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        let validStaff: number[] = [];
        this.allStaffs = data.staffList;
        let staffs = data.staffList;
        if(this.staffAppointmentTypeLinks.length > 0)
        {
          staffs = this.allStaffs.filter((staff:any) => this.staffAppointmentTypeLinks.find( link => staff.id == link.staff_id));
        }
        this.getAccessedStaffList$ = staffs.filter((staff: any) => {
          let oStaffStatus = this.OStaffStatus.find((o: any) => (o.value == staff.status || o.key == staff.status));
          if (oStaffStatus!.value == StaffStatus.Active || oStaffStatus!.key == StaffStatus.Active) {
            validStaff.push(staff.id);
            return staff;
          }
        });
        this.filterStaffIds.next(validStaff);
      }
    });
  }

  GetStaffAppointmentLink(appointmentTypeId: number) {
    this.staffAppointmentTypeLinkService.GetStaffAppointmentLinkByCategoryId(this.tenantId,appointmentTypeId)
      .subscribe((response: StaffAppointmentTytpeLinkResponse) => {
        this.staffAppointmentTypeLinks = response.items ? response.items : [];
        if (this.staffAppointmentTypeLinks.length > 0) {
          let validStaff: number[] = [];
          let staffs = this.allStaffs.filter((staff:any) => this.staffAppointmentTypeLinks.find( link => staff.id == link.staff_id));
          this.getAccessedStaffList$ = staffs.filter((staff: any) => {
            let oStaffStatus = this.OStaffStatus.find(
              (o: any) => o.value == staff.status || o.key == staff.status
            );
            if (oStaffStatus!.value == StaffStatus.Active || (oStaffStatus!.key == StaffStatus.Active)) {
              if (staff.role.toLowerCase() == 'admin' || (staff.role.toLowerCase() == 'staff')) {
                validStaff.push(staff.id);
                return staff;
              }
            }
          });
          this.filterStaffIds.next(validStaff);
          this.cd.detectChanges();
        }
      });
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  handleError(error: any) {
    this.error.next(error);
    this.showErrorPopup$.next(true);
  }

  CreateDuplicateAppointment(form: any) {
    if (this.duplicateAppointmentForm.valid) {
      this.disableSaveBtn = true;
      let createAppointment: CreateAppointmentRequest = {} as CreateAppointmentRequest;
      let createRecurringAppointment: CreateRecurringAppointmentRequest = {} as CreateRecurringAppointmentRequest;
      createAppointment.appointment_type_id = this.appointment!.type_id;
      createAppointment.client_id = form.value.client_id;
      createAppointment.coach_id = form.value.selectedTrainer.id;
      createAppointment.comments = form.value.comments;
      createAppointment.is_virtual = this.isVirtal;
      createAppointment.virtual_url = form.value.virtualUrl;
      createAppointment.room_id = form.value.selectedRoom ? form.value.selectedRoom.id : 0,
        createAppointment.start_date_time = this.timeConversionService.ConvertLocalDateTimeToUTC(form.value.startDate);
      createAppointment.subtype_id = this.GetApptSubTypeFormControl ? this.GetApptSubTypeFormControl.id : 0;
      createRecurringAppointment = createAppointment;
      if (this.RRuleObject.RRule) {
        createRecurringAppointment.recurring_rule = this.RRuleObject.RRule;
        createRecurringAppointment.recurring_start_date = createAppointment.start_date_time;
        createRecurringAppointment.start_time = this.timeConversionService.GetUTCTimeFromDate(form.value.startTime);

        this.appointmentService.CreateRecurringAppointment(this.tenantId, createRecurringAppointment)
          .subscribe({
            next: async (response: any) => {
              this.translate.get('SCHEDULE.MSG.CREATE_RECURRING_APPT_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.disableSaveBtn = false;
              await this.timeout(1000)
              this.HideDuplicatePopup(true);
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      } else {
        this.appointmentService.CreateAppointment(this.tenantId, createAppointment)
          .subscribe({
            next: async (response: any) => {
              this.translate.get('SCHEDULE.MSG.CREATE_APPT_MSG')
                .subscribe(async (translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.disableSaveBtn = false;
              await this.timeout(1000)
              this.HideDuplicatePopup(true);
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      }
    }
    else {
      Object.keys(this.duplicateAppointmentForm.controls).forEach((field) => {
        const control = this.duplicateAppointmentForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  HideDuplicatePopup(reloadData: boolean) {
    if (!this.disableSaveBtn) {
      this.duplicateAppointment = false;
      this.hideDuplicateAppointment.emit({ closePopup: this.duplicateAppointment, reloadData: reloadData });
    }

  }

  HideErrorPopup(event: any) {
    this.showErrorPopup$?.next(false);
    this.errorMessages = [];
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  clientStatus(client: any | null): string {
    if (client && (client.client_status || (client as any)?.client_status))
      return this.clientService.getClientStatusHtml(
        (client.client_status || (client as any)?.client_status).toString()
      );
    else return '';
  }

  ToggleVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.SelectedRoomFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValidators(null);
    } else {
      this.SelectedRoomFormControl.setValidators(this.selectedApptType && this.selectedApptType.is_room_mandatory ? Validators.required : null);
      this.VirtualUrlFormControl.setValidators(null);
    }
  }


  selectAction(action: any) {
    switch (action.value.name) {
      case 'PHYSICAL':
        this.ToggleVirtual(false);
        break;
      case 'VIRTUAL':
        this.ToggleVirtual(true);
        break;
    }
  }

  get GetSelectedRoomForDuplicate(): any {
    return this.duplicateAppointmentForm.controls.selectedRoom.value;
  }

  get SelectedTrainerFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls
      .selectedTrainer as FormControl;
  }

  get SelectedBehaviourFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls.selectedBehaviourType as FormControl;
  }

  get GetSelectedBehaviour(): FormControl {
    return this.duplicateAppointmentForm.controls.selectedBehaviourType.value;
  }

  get StartDateFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls.startDate as FormControl;
  }

  get SelectedRoomFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls.selectedRoom as FormControl;
  }

  get SelectedApptSubTypeFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls.selectedApptSubType as FormControl;
  }

  get GetApptSubTypeFormControl(): any {
    return this.duplicateAppointmentForm.controls.selectedApptSubType.value;
  }

  get Getcomments(): any {
    return this.duplicateAppointmentForm.controls.comments.value;
  }

  get VirtualUrlFormControl(): FormControl {
    return this.duplicateAppointmentForm.controls.virtualUrl as FormControl;
  }

  get GetVirtualUrl(): any {
    return this.duplicateAppointmentForm.controls.virtualUrl.value;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus).filter(key => typeof key[1] != 'number').map(([key, value]) => ({ key, value }));
  }

}